/**
 * Copyright (c) 2016-present GlossGenius. All rights reserved.
 */

import React from 'react';

import { useAppContext } from 'hooks/context/useAppContext';

import s from './Navigation.module.css';

const NavItemHome = () => {
  const { publicUser } = useAppContext();

  if (!publicUser) {
    return <h2>Home</h2>;
  }

  return <h2 className={s.businessName}>{publicUser.business_name}</h2>;
};

export { NavItemHome };
